import api from '../api';

import { ParamsDataPerfilUser } from 'utils/typeServices';

type ParamsReponse = {
    Data: {
        DadosDoPerfil: ParamsDataPerfilUser;
    }
}

export const GetPerfilUser = async ({ token, nrPlatform }: { token: string, nrPlatform: number }) => {
    try {
        const { data } = await api.get<ParamsReponse>(`v1/Cliente/PerfilUser/${nrPlatform}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data.DadosDoPerfil };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
